"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "NcCache", {
    enumerable: true,
    get: function() {
        return NcCache;
    }
});
function NcCache(_options) {
    return (_target, _propertyKey, descriptor)=>{
        return descriptor;
    };
}
